// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"0d6a91aa","312":"87a3ed72","333":"ebe40677","336":"599ae47f","337":"9c198843","453":"98a01d27","515":"57140701","594":"e801ae53","638":"d4575c96","749":"cdff7d83","966":"cdd5084c"}[chunkId] + ".chunk.js";
};